<template>
	<el-row class="homemainbigbox">
		<!-- banner -->
		<el-row class="bannerbox">
			<banner></banner>
		</el-row>
		<el-row class="main">
			<mainOne></mainOne>
			<mainTwo></mainTwo>
			<mainThree></mainThree>
			<mainFour></mainFour>
			<foot></foot>
		</el-row>
	</el-row>
</template>

<script>
	import banner from './components/banner.vue';
	import mainOne from './components/mainOne.vue';
	import mainTwo from './components/mainTwo.vue';
	import mainThree from './components/mainThree.vue';
	import mainFour from './components/mainFour.vue';
	import foot from '@/views/foot/index.vue';
 export default {
		components:{
			banner:banner,
			mainOne:mainOne,
			mainTwo:mainTwo,
			mainThree:mainThree,
			mainFour:mainFour,
			foot:foot,
		},
        data(){
          return{

          }
        },
        methods:{

        },

}
</script>

<style lang="less" scoped>
	.homemainbigbox {
		width: 100%;
		height: auto;
		.main{
			height: auto;
			width: 100%;
		}
	}
</style>
